// UI strings of the article display side (card, reader, profile tab). Translations live in
// image/longform/frontend/locales.display.json and are merged into the locale files by edits/display.mjs.
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pill: {
    id: 'whocare_article.pill',
    defaultMessage: 'Article · {minutes} min',
  },
  readMore: { id: 'whocare_article.read_more', defaultMessage: 'Read more' },
  readingTime: {
    id: 'whocare_article.reading_time',
    defaultMessage: '{minutes} min read',
  },
  edited: { id: 'whocare_article.edited', defaultMessage: 'Edited {date}' },
  edit: { id: 'whocare_article.edit', defaultMessage: 'Edit article' },
  toc: { id: 'whocare_article.toc', defaultMessage: 'Contents' },
  tab: { id: 'whocare_article.tab', defaultMessage: 'Articles' },
  empty: {
    id: 'whocare_article.empty',
    defaultMessage: 'No articles yet.',
  },
  emptySelf: {
    id: 'whocare_article.empty_self',
    defaultMessage: 'Articles you publish will show up here.',
  },
  write: { id: 'whocare_article.write', defaultMessage: 'Write an article' },
  loadError: {
    id: 'whocare_article.load_error',
    defaultMessage: 'Could not load the articles.',
  },
  retry: { id: 'whocare_article.retry', defaultMessage: 'Try again' },
  // reader translation (same wording as the stock status translate button)
  translate: { id: 'whocare_article.translate', defaultMessage: 'Translate' },
  translating: {
    id: 'whocare_article.translating',
    defaultMessage: 'Translating…',
  },
  showOriginal: {
    id: 'whocare_article.show_original',
    defaultMessage: 'Show original',
  },
  translatedFrom: {
    id: 'whocare_article.translated_from',
    defaultMessage: 'Translated from {lang} using {provider}',
  },
});
